export enum TargetApplication {
    Manager = "manager",
    IdHub = "idhub",
    Property = "property",
}
